import set from 'lodash.set';
import types from './constants';

const defaultReducer = (state) => (state);

const isListeningChange = (state, action) => {
  let next = JSON.parse(JSON.stringify(state));
  set(next, 'listener', {isListening: action.isListening});
  return next;
}

const actionReducer = {
  [types.IS_LISTENING_CHANGE]: isListeningChange,
};

export default (state = {}, action = {type: null}) => {
  const reducer = actionReducer[action.type] || defaultReducer;
  return reducer(state, action);
}
